'use strict';
import React from 'react';
import * as ReactRedux from 'react-redux';

import { LatestListings } from './latest-listings';
import { ValuePropositionPanelsHome } from '../../views/home/value-proposition-panels';
import { CategoriesHomeComponent as CategoriesHome } from '../../views/home/categories';
import { ServicesHomeComponent } from '../../views/home/services';
import BannersHome from '../../views/home/banners';
import TitlePanelsHome from '../../views/home/title-panels';
import CallToActionPanelsHome from '../../views/home/call-to-action-panels';
import BaseComponent from '../shared/base';
import EnumCoreModule from '../../public/js/enum-core';

import { loadMore, loadLess } from '../../redux/categoryActions';

class HomepageWithPanelComponent extends BaseComponent {
    componentDidMount() {
        if (typeof document === 'undefined' || typeof window === 'undefined') {
            return;
        }

        let self = this;

        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error');

        if (typeof error != 'undefined') {
            if (error == 'invalid-token') {
                self.showMessage(EnumCoreModule.GetToastStr().Error.INVALID_TOKEN);
            }
            if (error == 'merchant-not-found') {
                self.showMessage({
                    type: 'error',
                    body: 'This page is no longer accessible.',
                    header: 'Sorry!'
                });
            }
        }

        // document.getElementById('homepageService').addEventListener('click', function() {
        //     self.scrollToSectionWithPadding('services')
        // });

        // document.getElementById('homepageRent').addEventListener('click', function() {
        //     self.scrollToSectionWithPadding('rentals')
        // });
    }

    scrollToSectionWithPadding(sectionId) {
        var targetSection = document.getElementById(sectionId);
        let headerHeight = 150;
        var offsetTop = targetSection.offsetTop - headerHeight;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }

    getBannerPanel() {
        if (this.props.panels != null) {
            const bannerPanel = this.props.panels.filter(p => p.Type.toLowerCase() === 'slider');
            if (bannerPanel && bannerPanel.length > 0) {
                return bannerPanel[0];
            }
        }
        return null;
    }

    renderDefault() {
        return (
            <React.Fragment>
                <CategoriesHome
                    categories={this.props.categories}
                    numberOfCategories={this.props.numberOfCategories}
                    collapsableCategories={this.props.collapsableCategories}
                />
                {/* <RentalsHomeComponent categories={this.props.categories} numberOfCategories={this.props.numberOfCategories} collapsableCategories={this.props.collapsableCategories} /> */}
                {/* <ItemsHome
                    items={this.props.items}
                    itemLayoutCount={this.props.itemLayoutCount}
                    user={this.props.user}
                    userPreferredLocationId={this.props.userPreferredLocationId}
                /> */}
            </React.Fragment>
        );
    }

    renderPanels() {
        var self = this;
        var panelViews = this.props.panels.map(function (panel, index) {
            if (panel.Type == 'Categories') {
                if (panel.IsVisible) {
                    return (
                        <CategoriesHome
                            categories={self.props.categories}
                            numberOfCategories={self.props.numberOfCategories}
                            loadMore={self.props.loadMore}
                            collapsableCategories={self.props.collapsableCategories}
                            loadLess={self.props.loadLess}
                            key={index}
                        />
                    );
                }
            } else if (panel.Type == 'LatestItems') {
                if (panel.IsVisible) {
                    return (
                        <LatestListings
                            key={`latest-items-${index}`}
                            userID={self.props.user?.ID}
                            layoutItemCount={self.props.layoutItemCount}
                        />
                    );
                }
            } else if (panel.Type == 'Title') {
                return <TitlePanelsHome panel={panel} key={index} />;
            } else if (panel.Type == 'CalltoAction') {
                return <CallToActionPanelsHome panel={panel} key={index} />;
            } else if (panel.Type == 'ValueProposition') {
                if (panel.IsVisible) {
                    return <ValuePropositionPanelsHome panel={panel} key={index} />;
                }
            }
        });
        return panelViews;
    }

    render() {
        return (
            <div className='home-pg-container tw-w-full'>
                <BannersHome panel={this.getBannerPanel()} user={this.props.user} />

                <div className='category-list-outer'>
                    <div className='container-fluid'>
                        <div className='row'>
                            {/* <RentalsHomeComponent categories={this.props.categories} numberOfCategories={this.props.numberOfCategories} collapsableCategories={this.props.collapsableCategories} /> */}
                            <ServicesHomeComponent
                                categories={this.props.categories}
                                numberOfCategories={this.props.numberOfCategories}
                                collapsableCategories={this.props.collapsableCategories}
                            />
                            {this.props.panels != null ? this.renderPanels() : this.renderDefault()}
                            {/* <GroupPanelComponent/> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.userReducer.user,
        userPreferredLocationId: state.userReducer.userPreferredLocationId,
        categories: state.categoryReducer.categories,
        numberOfCategories: state.categoryReducer.numberOfCategories,
        panels: state.panelsReducer.panels,
        layoutItemCount: state.settingsReducer.layoutItemCount,
        collapsableCategories: state.settingsReducer.collapsableCategories,
        isBespoke: state.settingsReducer.isBespoke
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadMore: () => dispatch(loadMore()),
        loadLess: () => dispatch(loadLess())
    };
}

const HomepageWithPanelHome = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(HomepageWithPanelComponent);

export { HomepageWithPanelHome, HomepageWithPanelComponent };

export default {
    HomepageWithPanelHome,
    HomepageWithPanelComponent
};
